import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import { BsFillExclamationCircleFill } from "react-icons/bs";
import style from "./Modal.module.scss";
import React, { useEffect, useState } from "react";
import { tabForm } from "../../.config";

const TODIS_MODAL_VALIDATE = (props) => {

    const[errors, setErrors] = useState([])

    useEffect(() => {
        let claves = Object.keys(props.errors);
        let prevError = [];
        for(let i=0; i< claves.length; i++){
            let clave = claves[i];
            if(typeof (props.errors[clave]) === "object"){
                let claves2 = Object.keys(props.errors[clave]);
                for(let i=0; i< claves2.length; i++){
                    let clave2 = claves2[i];
                    prevError.push({name: tabForm[clave], text: props.errors[clave][clave2]})
                }
            }else{
                prevError.push({name: "General", text: props.errors[clave]})
            }
        }
        setErrors(prevError)
        return () => {
            setErrors([])
          };
    }, [props.errors])
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className={style.todisModalContainer}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Data Validation
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row >
                    <div className={style.scroll}>
                        {
                            
                        (errors.map((error,index)=>(
                            
                        <Col lg={12} className={`${style.dataInfo}`} key={index}>
                            <Container className="ms-2">
                                <Row>
                                    <Col lg={1} className="p-0 w-auto"> 
                                            <Row className="pe-4">
                                                <span style={{backgroundColor:"red", borderRadius:"10px", paddingLeft:"5px", paddingRight:"5px", height:"50px"}}><BsFillExclamationCircleFill style={{width:"40px", height:"50px"}} className="m-0" color="#fff"/></span>
                                            </Row> 
                                    </Col>
                                    <Col lg={11}>
                                        <h7 className="fw-bold"><span className="fw-lighter">Error at  </span>{error.name} Section</h7>
                                        <Row>
                                            <Col lg={3} className="w-auto">
                                                <span> Message: {error.text}</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>)))
                        }
                    </div>
                    </Row>
                </Container>
            </Modal.Body>
             <Modal.Footer>
                <Container>
                <diV style={{textAlign:"center"}}>
                    <span style={{color:"red",fontWeight:"bold"}}> {errors.length} Errors Ocurred !</span>
                </diV>
                </Container>
            </Modal.Footer> 
        </Modal>
    )
}

export { TODIS_MODAL_VALIDATE };